var Vendd = (function (Vendd) {
    'use strict';

    Vendd.ElasticSearch = (function (ElasticSearch) {

        ElasticSearch.Messages = (function (Messages) {

            Messages.GetCategoryElasticResults = function (searchTerm, pageFrom, pageSize) {
                var data = {
                    searchTerm: searchTerm,
                    pageFrom: pageFrom,
                    pageSize: pageSize
                };
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.ElasticSearch.Messages.GetCategoryElasticResults", data);
            };
            Messages.GetCategoryElasticResults.className = "Vendd.ElasticSearch.Messages.GetCategoryElasticResults";

            Messages.GetCategoryElasticResultsSuccess = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.ElasticSearch.Messages.GetCategoryElasticResultsSuccess", data);
            };
            Messages.GetCategoryElasticResultsSuccess.className = "Vendd.ElasticSearch.Messages.GetCategoryElasticResultsSuccess";

            Messages.GetCategoryElasticResultsFailed = function (response) {
                response.data = JSON.parse(response.data);
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.ElasticSearch.Messages.GetCategoryElasticResultsFailed", response);
            };
            Messages.GetCategoryElasticResultsFailed.className = "Vendd.ElasticSearch.Messages.GetCategoryElasticResultsFailed";

            Messages.GetProductElasticResults = function (searchTerm, pageFrom, pageSize, sortingKey, orderType) {
                var data = {
                    searchTerm: searchTerm,
                    pageFrom: pageFrom,
                    pageSize: pageSize,
                    sortingKey: sortingKey,
                    orderType: orderType
                };
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.ElasticSearch.Messages.GetProductElasticResults", data);
            };
            Messages.GetProductElasticResults.className = "Vendd.ElasticSearch.Messages.GetProductElasticResults";

            Messages.GetProductElasticResultsSuccess = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.ElasticSearch.Messages.GetProductElasticResultsSuccess", data);
            };
            Messages.GetProductElasticResultsSuccess.className = "Vendd.ElasticSearch.Messages.GetProductElasticResultsSuccess";

            Messages.GetProductElasticResultsFailed = function (response) {
                response.data = JSON.parse(response.data);
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.ElasticSearch.Messages.GetProductElasticResultsFailed", response);
            };
            Messages.GetProductElasticResultsFailed.className = "Vendd.ElasticSearch.Messages.GetProductElasticResultsFailed";

            return Messages;

        })(ElasticSearch.Messages || {});

        return ElasticSearch;

    })(Vendd.ElasticSearch || {});

    return Vendd;

})(Vendd || {});